import { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ModalContext, useGlobalStore } from '../../../components/contexts';
import ValidateService from '../../../services/ValidateService';
import ResVideoDetailController from '../../../controllers/aia/ResVideoDetailController';
import ColloredTd from '../../../components/tableComponents/ColloredTd';

const AnalyzeTotalResult = ({ param }) => {
  const [pageParam, setPageParam] = useState({ ...param });

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const naviagte = useNavigate();

  const [loadData, setLoadData] = useState([]);
  const [scrData, setScrData] = useState([]);

  const controller = useMemo(() => {
    return new ResVideoDetailController(
      { store, updateStore },
      { pageParam, setPageParam },
      { loadData, setLoadData },
      { scrData, setScrData },
      modalService,
      validateService,
      naviagte
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    if (
      pageParam !== undefined &&
      pageParam !== null &&
      pageParam?.entSn !== undefined &&
      pageParam?.entSn !== null &&
      pageParam?.entSn !== '' &&
      pageParam?.anlsAplyId !== undefined &&
      pageParam?.anlsAplyId !== null &&
      pageParam?.anlsAplyId !== '' &&
      pageParam?.vdoId !== undefined &&
      pageParam?.vdoId !== null &&
      pageParam?.vdoId !== ''
    ) {
      controller.fnSearch();
    }
  }, [pageParam]);

  return (
    <>
      <div className="tbl-wrap">
        <div className="img-wrap">
          <div className="img-item">
            {loadData.length > 0 && (
              <img src={loadData[0].thmbFile} alt="영상 분석 결과 이미지" />
            )}
          </div>
        </div>
        <table className="tbl row data scroll divide">
          <colgroup>
            <col style={{ width: '6.6%' }} />
            <col />
            <col />
            <col />
            <col style={{ width: '33.2%' }} />
          </colgroup>

          <tbody>
            <tr>
              <th className="bg1" rowspan="2">
                작업부가정보
              </th>
              <th>무게</th>
              <th>빈도/강도</th>
              <th>손잡이</th>
              <th>추가사항</th>
            </tr>
            <tr>
              <td>
                <div className="inner-list">
                  <div className="form-check">
                    <input
                      type="radio"
                      id="weight1"
                      name="weight"
                      value="WT_01"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.weight === 'WT_01'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="weight1">2kg미만</label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="weight2"
                      name="weight"
                      value="WT_02"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.weight === 'WT_02'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="weight2">2~5kg</label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="weight3"
                      name="weight"
                      value="WT_03"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.weight === 'WT_03'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="weight3">5~10kg</label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="weight4"
                      name="weight"
                      value="WT_04"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.weight === 'WT_04'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="weight4">10~20kg</label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="weight5"
                      name="weight"
                      value="WT_05"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.weight === 'WT_05'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="weight5">20kg이상</label>
                  </div>
                </div>
              </td>
              <td>
                <div className="inner-list">
                  <div className="form-check">
                    <input
                      type="radio"
                      id="freq1"
                      name="freqIntens"
                      value="FQ_01"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.freqIntens === 'FQ_01'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="freq1" style={{ textAlign: 'left' }}>
                      가끔 물건을 들어올림
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="freq2"
                      name="freqIntens"
                      value="FQ_02"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.freqIntens === 'FQ_02'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="freq2" style={{ textAlign: 'left' }}>
                      정적이거나 반복작업을 수행
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="freq3"
                      name="freqIntens"
                      value="FQ_03"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.freqIntens === 'FQ_03'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="freq3" style={{ textAlign: 'left' }}>
                      갑작스럽게 물건을 들어올리거나 충격을 받음
                    </label>
                  </div>
                </div>
              </td>
              <td>
                <div className="inner-list">
                  <div className="form-check">
                    <input
                      type="radio"
                      id="handle1"
                      name="coupling"
                      value="HD_01"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.coupling === 'HD_01'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="handle1" style={{ textAlign: 'left' }}>
                      좋음(적절한 손잡이)
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="handle2"
                      name="coupling"
                      value="HD_02"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.coupling === 'HD_02'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="handle2" style={{ textAlign: 'left' }}>
                      보통(대용 손잡이)
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="handle3"
                      name="coupling"
                      value="HD_03"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.coupling === 'HD_03'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="handle3" style={{ textAlign: 'left' }}>
                      나쁨(부적절한 손잡이)
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="handle4"
                      name="coupling"
                      value="HD_04"
                      onChange={e => {
                        controller.loadDataChange(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      checked={loadData?.[0]?.coupling === 'HD_04'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="handle4" style={{ textAlign: 'left' }}>
                      부적절(손잡이 없음)
                    </label>
                  </div>
                </div>
              </td>

              <td>
                <div className="inner-list">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      name="staticYn"
                      id="chk_1"
                      onClick={e => {
                        controller.loadDataChange(
                          'staticYn',
                          e.target.checked ? 'Y' : 'N'
                        );
                      }}
                      checked={loadData?.[0]?.staticYn === 'Y'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="chk_1" style={{ textAlign: 'left' }}>
                      <span>1분이상 정적자세</span>
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      name="reptYn"
                      id="chk_2"
                      onClick={e => {
                        controller.loadDataChange(
                          'reptYn',
                          e.target.checked ? 'Y' : 'N'
                        );
                      }}
                      checked={loadData?.[0]?.reptYn === 'Y'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="chk_2" style={{ textAlign: 'left' }}>
                      <span>분당 4회 이상 반복</span>
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      name="unstableYn"
                      id="chk_3"
                      onClick={e => {
                        controller.loadDataChange(
                          'unstableYn',
                          e.target.checked ? 'Y' : 'N'
                        );
                      }}
                      checked={loadData?.[0]?.unstableYn === 'Y'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="chk_3" style={{ textAlign: 'left' }}>
                      <span>
                        동작으로 자세가 급변하거나 불안정한 지지면에서 수행됨
                      </span>
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      name="upperArmSupportedYn"
                      id="chk_4"
                      onClick={e => {
                        controller.loadDataChange(
                          'upperArmSupportedYn',
                          e.target.checked ? 'Y' : 'N'
                        );
                      }}
                      checked={loadData?.[0]?.upperArmSupportedYn === 'Y'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="chk_4" style={{ textAlign: 'left' }}>
                      <span>팔이 지지되거나 몸을 어딘가에 기댐</span>
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      name="legSittedSupportedYn"
                      id="chk_5"
                      onClick={e => {
                        controller.loadDataChange(
                          'legSittedSupportedYn',
                          e.target.checked ? 'Y' : 'N'
                        );
                      }}
                      checked={loadData?.[0]?.legSittedSupportedYn === 'Y'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="chk_5" style={{ textAlign: 'left' }}>
                      <span>앉은 자세(허리 지지됨)</span>
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      name="legSittedNotSupportedYn"
                      id="chk_6"
                      onClick={e => {
                        controller.loadDataChange(
                          'legSittedNotSupportedYn',
                          e.target.checked ? 'Y' : 'N'
                        );
                      }}
                      checked={loadData?.[0]?.legSittedNotSupportedYn === 'Y'}
                      disabled={true}
                      className={'readOnly'}
                    />
                    <label htmlFor="chk_6" style={{ textAlign: 'left' }}>
                      <span>앉은 자세(허리 지지 않됨)</span>
                    </label>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="tbl-wrap">
          {scrData.length > 0 &&
            scrData.map(item => {
              return (
                <table className="tbl row data scroll divide">
                  <colgroup>
                    <col style={{ width: '6.7%' }} />
                    <col style={{ width: '26%' }} />
                    <col style={{ width: '5.1%' }} />
                    <col style={{ width: '26%' }} />
                    <col style={{ width: '5.1%' }} />
                    <col style={{ width: '26%' }} />
                    <col style={{ width: '5.1%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th rowspan="23" className="bg1">
                        <div
                          style={{
                            transform: 'rotate(-90deg)',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {item.anlsTrprLbl}
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th colspan="2" className="bg1">
                        목
                      </th>
                      <th colspan="2" className="bg1">
                        허리
                      </th>
                      <th colspan="2" className="bg1">
                        다리
                      </th>
                    </tr>
                    <tr>
                      <th>자세구분</th>
                      <th>시간(초)</th>
                      <th>자세구분</th>
                      <th>시간(초)</th>
                      <th>자세구분</th>
                      <th>시간(초)</th>
                    </tr>
                    <tr>
                      <td>뒤로 젖힘</td>
                      <td>{item.neckBendBelow}</td>
                      <td>-20도 이상 뒤로</td>
                      <td>{item.trunkBendBelow20}</td>
                      <td>앉은 자세</td>
                      <td>{item.legSit}</td>
                    </tr>
                    <tr>
                      <td>0~10도 굽힘</td>
                      <td>{item.neckBendFront0}</td>
                      <td>20도 ~ 0도 뒤로</td>
                      <td>{item.trunkBendBelow0}</td>
                      <td>두 다리를 펴고 선 자세</td>
                      <td>{item.legStandTwoLegs}</td>
                    </tr>
                    <tr>
                      <td>10~20도 굽힘</td>
                      <td>{item.neckBendFront10}</td>
                      <td>똑바로</td>
                      <td>{item.trunkBendNo}</td>
                      <td>한 다리로 선 자세</td>
                      <td>{item.legStandOneLegs}</td>
                    </tr>
                    <tr>
                      <td>20도 이상 굽힘</td>
                      <td>{item.neckBendFront20}</td>
                      <td>0~20도 굽힘</td>
                      <td>{item.trunkBend0}</td>
                      <td>두 다리를 구부린 선 자세</td>
                      <td>{item.legStandTwoLegsBended}</td>
                    </tr>
                    <tr>
                      <td>비틀림</td>
                      <td>{item.neckTwisted}</td>
                      <td>20도 ~ 60도 굽힘</td>
                      <td>{item.trunkBend20}</td>
                      <td>한 다리로 서서 구부린 선 자세</td>
                      <td>{item.legStandOneLegsBended}</td>
                    </tr>
                    <tr>
                      <td>옆으로 구부림</td>
                      <td>{item.neckBended}</td>
                      <td>60도 이상 굽힘</td>
                      <td>{item.trunkBend60}</td>
                      <td>무릎을 꿇는 자세</td>
                      <td>{item.legSitTwoLegsBended}</td>
                    </tr>
                    <tr>
                      <td>-</td>
                      <td>-</td>
                      <td>비틀림</td>
                      <td>{item.trunkTwisted}</td>
                      <td>걷기</td>
                      <td>{item.legWalk}</td>
                    </tr>
                    <tr>
                      <td>-</td>
                      <td>-</td>
                      <td>옆으로 구부림</td>
                      <td>{item.trunkBended}</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>

                    <tr>
                      <th colspan="2" className="bg1">
                        어깨
                      </th>
                      <th colspan="2" className="bg1">
                        팔
                      </th>
                      <th colspan="2" className="bg1">
                        손목
                      </th>
                    </tr>
                    <tr>
                      <th>자세구분</th>
                      <th>시간(초)</th>
                      <th>자세구분</th>
                      <th>시간(초)</th>
                      <th>자세구분</th>
                      <th>시간(초)</th>
                    </tr>
                    <tr>
                      <td>-20도 이상 뒤로</td>
                      <td>{item.shoulderBack20}</td>
                      <td>양 팔 어깨 아래</td>
                      <td>{item.armBelowShoulder}</td>
                      <td>15도 이상 들림</td>
                      <td>{item.wristRaised15}</td>
                    </tr>
                    <tr>
                      <td>-20도 뒤로 ~ 20도 앞으로</td>
                      <td>{item.shoulderBetween}</td>
                      <td>한 팔 어깨 위</td>
                      <td>{item.oneArmOverShoulder}</td>
                      <td>중립</td>
                      <td>{item.wristNeutral}</td>
                    </tr>
                    <tr>
                      <td>20~45도 앞으로</td>
                      <td>{item.shoulderFront20}</td>
                      <td>양팔 어깨 위</td>
                      <td>{item.twoArmOverShoulder}</td>
                      <td>-15아래 ~ 15도 사이</td>
                      <td>{item.wristMid}</td>
                    </tr>
                    <tr>
                      <td>45~90도 앞으로</td>
                      <td>{item.shoulderFront45}</td>
                      <td>0~60도(위팔 수직선에서)</td>
                      <td>{item.lowerArm0}</td>
                      <td>15도 이상 꺽임</td>
                      <td>{item.wristOver15}</td>
                    </tr>
                    <tr>
                      <td>90도 이상 위로</td>
                      <td>{item.shoulderFront90}</td>
                      <td>60 ~ 100도(위팔 수직선에서)</td>
                      <td>{item.lowerArm60}</td>
                      <td>중립에서 비틀림</td>
                      <td>{item.wristTwistedHalf}</td>
                    </tr>
                    <tr>
                      <td>위팔 벌어지거나 회전</td>
                      <td>{item.upperArmAbducted}</td>
                      <td>100도 이상(위팔 수직선에서)</td>
                      <td>{item.lowerArm100}</td>
                      <td>손목이 완전히 비틀림</td>
                      <td>{item?.wristTwistedAll}</td>
                    </tr>
                    <tr>
                      <td>어깨들림</td>
                      <td>{item.upperArmRaised}</td>
                      <td>팔이 교차 또는 몸통을 벗어남</td>
                      <td>{item.lowerArmOutbody}</td>
                      <td>손목이 옆으로 굽혀짐</td>
                      <td>{item.wristBended}</td>
                    </tr>
                    <tr>
                      <td>팔이 지지되거나 몸을 어딘가에 기댐</td>
                      <td>{item.upperArmSupported}</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <th colSpan={2}>OWAS 최고점수</th>
                      <th colSpan={2}>RULA 최고점수</th>
                      <th colSpan={2}>REBA 최고점수</th>
                    </tr>
                    <tr>
                      <ColloredTd
                        scrType="OWAS"
                        colSpan={2}
                        scr={item.owasMax}
                      />
                      <ColloredTd
                        scrType="RULA"
                        colSpan={2}
                        scr={item.rulaMax}
                      />
                      <ColloredTd
                        scrType="REBA"
                        colSpan={2}
                        scr={item.rebaMax}
                      />
                    </tr>
                  </tbody>
                </table>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default AnalyzeTotalResult;
